import VCard from "vcard-creator";
import mySvg from "../images/addcontact_button.svg";
import celcom_logo from "../images/celcom_logo.svg";
import dialog from "../images/dialog_logo.svg";
import xlaxiat from "../images/xlaxiata_logo.svg";

import smart_logo from "../images/smart_logo.svg";
import robi_logo from "../images/robi_logo.svg";
import ncell_logo from "../images/ncell_logo.svg";

import edotco_logo from "../images/EDOTCO-Full-Color.png";
import ada_logo from "../images/ada_logo.svg";
import axiatadigitallabs_logo from "../images/axiatadigitallabs_logo.svg";
import boost_logo from "../images/boost_logo.svg";
import link_net_logo from "../images/linknet_logo.svg";
//import location from "../images/location.png";
//import mail from "../images/mail.png";
//import web from "../images/web.png";
//import phone from "../images/phone.png";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { browserName, osName } from "react-device-detect";
import AlertMessage from "./AlertMessage";
import main_logo from "../images/Logo.svg";

import "../styles/dashboard.css";
import modifiedLogo from '../images/modifiedLogo.png'
import contact from '../images/contact_white.png'
import location from '../images/profilelocation.png'
import mail from '../images/profilemessage.png'
import website from '../images/profileweb.png'
import profilephone from '../images/profilephone.png';
import * as htmlToImage from "html-to-image";



const Profile = ({ qr_url }) => {
  const getEncryptedTxt = (url) => {
    const path = url.split("/");
    console.log(path, "path");
    return path[4];
  };

  let { url } = useParams();
  url = qr_url ? getEncryptedTxt(qr_url) : url;
  const [userProfile, setUserProfile] = useState([]);
  const [errorMessage, setErrorMessage] = useState(false);
  useEffect(() => {
    let headers = new Headers({ "Access-Control-Allow-Origin": "*" });
    headers.append("Content-Type", "application/json");
    const body = JSON.stringify({
      encryptedRequest: {
        encryptedText: decodeURIComponent(url),
      },
      userAgentDTO: {
        // ipaddress: "10.10.12.19",
        // email: "hello@gmail.com",
        deviceType: browserName,
        operatingSystem: osName,
      },
    });
    fetch("/retrievebusinesscardapi/", {
      method: "POST",
      body,
      headers,
    })
      .then((res) => res.json())
      .then((res) => {
        console.log(res, "res");
        setUserProfile(res);
      })
      .catch((e) => {
        setErrorMessage(true);
      });
  }, []);

  let designation = "testDest";
  let destarray = designation.split("$");
  let destarraylen = destarray.length;
  let phone = "898898989";
  let tellink = "tel:";
  tellink = tellink.concat(phone);

  const downloadBusinessCard = async () => {
    console.log("asdadsasda profileCard")
    // download business card
    const pricingTableElmt = document.querySelector(".profileCard");
    if (!pricingTableElmt) return;
    // const canvas = await html2canvas(pricingTableElmt);
    // const dataURL = canvas.toDataURL("image/png");
    // downloadjs(dataURL, "profilecard.png", "image/png");

    htmlToImage
      .toJpeg(document.querySelector(".profileCard"), { quality: 0.95 })
      .then(function (dataUrl) {
        var link = document.createElement("a");
        link.download = "profilecard.jpeg";
        link.href = dataUrl;
        link.click();
      });
  };

  const copyQRCode = async () => {
    var a = document.createElement("a"); //Create <a>
    a.href = "data:image/png;base64," + dashboardData.qr_code; //Image Base64 Goes here
    a.download = "qr.png"; //File name Here
    a.click();
    //document.body.removeChild(a);
  };

  const SaveContact = (e) => {
    e.preventDefault();
    console.log("The link was clicked.");
    // Define a new vCard
    const myVCard = new VCard();
    myVCard;
    // Add personal data
    //.addName(userProfile.firstName)
    // Add work data
    //.addCompany(userProfile.designation)
    //.addJobtitle(userProfile.designation)
    //.addEmail(userProfile.email)
    //.addPhoneNumber(userProfile.mobile, "PREF;WORK");
    //.addPhoneNumber(userProfile.mobile, "WORK");
    if (userProfile.firstName) {
      let name = userProfile.firstName;
      name = userProfile.secondName
        ? userProfile.firstName + " " + userProfile.secondName
        : name;
      myVCard.addName(userProfile.firstName);
    }
    if (userProfile.designation) {
      myVCard.addCompany(userProfile.designation);
    }
    if (userProfile.mobile) {
      myVCard.addPhoneNumber(userProfile.mobile, "PREF;WORK");
    }
    if (userProfile.email) {
      myVCard.addEmail(userProfile.email);
    }
    //console.log(myVCard.toString());
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/x-vcard;charset=utf-8," +
        encodeURIComponent(myVCard.toString())
    );
    element.setAttribute("download", userProfile.firstName + ".vcf");

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  };
  return (
    <div className="profile">
      {!errorMessage && (
        <div className="newDashboardBlock">
          <div className="newProfileDashboardLogo">
          <div className="mainLogo">
          <img src={modifiedLogo} />
        </div>
        </div>
           <div className="newProfileDashboard">
     

        <div className="textAlignC">
          {/* <h1 className="title">Vivek Sood </h1> */}
            {userProfile.firstName && (
            <h1 className="title">{userProfile.firstName}</h1>
          )}
          {userProfile.secondName && (
            <h1 className="title secondName">{userProfile.secondName}</h1>
          )}
          <h4>
          <div
  dangerouslySetInnerHTML={{ __html: userProfile.designation }}
/>
</h4>
        </div>


        <div className="flex-column columnLayOut">
          <div className="column-item">
            <div className="personalDetails">
              <div className="addMeContact">
                 <a
            className="addtocontactNew"
            href="javascript:void(0)"
            onClick={SaveContact}
          >
            <img src={contact} alt="logo" /> | Add me to your contact.
          </a>
                
              </div>
              <div><img src={profilephone} alt="logo" /> {userProfile.mobile}{" "}</div>
              <div> <img src={mail} alt="logo" />{userProfile.email}</div>
              <div> <img src={location} alt="logo" />Axiata  Group Berhad</div>
              <div><img src={website} alt="logo" /> www.axiata.com</div>
            </div>
          </div>
          <div className="column-item qrCodeItem "> <div className="qrCode">
             <img
              src={`data:image/png;base64,${userProfile.qrcode}`}
              className="barcodeImage blue-qr"
              alt="qr code"
            />
           
          </div>
          {/* <button
                        onClick={downloadBusinessCard}
                        className="button downloadBCard"
                      >
                        Download Business Card SBC
                      </button> */}
                      {/* <button
                        onClick={copyQRCode}
                        style={{ marginTop: "4%", fontSize: "16px" }}
                        className="button"
                      >
                        Download QR Code
                      </button> */}
          </div>

        </div>

      </div>
        
       
        </div>
      )}
      {errorMessage && (
        <div className="card">
          <AlertMessage
            variant={"danger"}
            onClose={() => setShowMessage(false)}
            showMessage={true}
          >
            Sorry Unable to process your request due to some technical problem
            right now, you may try again later!
          </AlertMessage>
        </div>
      )}
    </div>
  );
};

export default Profile;
